import React, { Suspense, lazy } from 'react';
import { connect } from 'react-redux';
import CircularLoading from '../commoncomponents/CircularLoading';
import { isSmallScreenBoolType } from '../../types';

const FrontPageDesktop = lazy(() => import('./FrontPageDesktop'));
const FrontPageMobile = lazy(() => import('./FrontPageMobile'));

const FrontPage = ({ isSmallScreen }) => (
  <Suspense fallback={<CircularLoading />}>
    {isSmallScreen ? <FrontPageMobile /> : <FrontPageDesktop />}
  </Suspense>
);

FrontPage.propTypes = {
  isSmallScreen: isSmallScreenBoolType.isRequired
};

const mapStateToProps = ({ isSmallScreen }) => {
  return { isSmallScreen };
};

const actions = {};

export default connect(mapStateToProps, actions)(FrontPage);
